import { useQuery } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import useAuth from '@sdk/authentication/useAuth';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';
import type { TimesheetHistoryItem } from '@sdk/timesheets/types/TimesheetHistory';

import { QueryKey } from '@web/timesheets/types/QueryKey';
import { mapTimesheetHistory } from '@web/timeClock/TimesheetHistory/timesheetHistory.utils';

export const useTimesheetHistory = (shiftId: string, userId: number) => {
  const api = useSlingApi();
  const { personasDict } = usePersonaCollection();
  const { currentUser } = useAuth();

  const { data: historyItems, refetch: fetchHistory } = useQuery<TimesheetHistoryItem[]>({
    queryKey: [QueryKey.TIMESHEET_HISTORY, shiftId],
    queryFn: async () => {
      const { data } = await api.timesheets.getHistory(shiftId, userId);
      return mapTimesheetHistory(data, personasDict, currentUser);
    },
  });

  return {
    historyItems,
    fetchHistory,
  };
};
